import React, { useEffect, useState } from "react";
import "./SearchNow.css";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { AllHealtConcern } from "../../../features/master/masterSlice";
import { useDispatch, useSelector } from "react-redux";
import { encodeId } from "../../../utils/common";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode } from "swiper/modules"; // Swiper v9+
import "swiper/css";
import "swiper/css/free-mode";

const categories = [
  { name: "Joint Pain", icon: "/assets/images/home/search_products/img1.png" },
  { name: "Diabetes", icon: "/assets/images/home/search_products/img2.png" },
  {
    name: "Skin Problem",
    icon: "/assets/images/home/search_products/img3.png",
  },
  { name: "Liver Issue", icon: "/assets/images/home/search_products/img4.png" },
  { name: "Joint Pain", icon: "/assets/images/home/search_products/img1.png" },
  { name: "Diabetes", icon: "/assets/images/home/search_products/img2.png" },
  {
    name: "Skin Problem",
    icon: "/assets/images/home/search_products/img3.png",
  },
  { name: "Liver Issue", icon: "/assets/images/home/search_products/img4.png" },
  { name: "Diabetes", icon: "/assets/images/home/search_products/img2.png" },
];

function SearchNow() {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const healt_concerns = useSelector((state) => state.master.healt_concerns);
  useEffect(() => {
    dispatch(AllHealtConcern());
  }, [dispatch]);

  const [search, setSearch] = useState("");

  return (
    <div className="Search-Now-section container">
      <div className=" wrapper">
        <div className="search-bar desktop">
          <div className="input-wrapper">
            <Form.Control
              type="text"
              placeholder="Search product here..."
              className="search-input"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  navigate(`/categories?search=${encodeURIComponent(search)}`);
                }
              }}
            />
            <FontAwesomeIcon icon={faMagnifyingGlass} className="search-icon" />
          </div>

          <button
            className="search-btn"
            onClick={() => {
              if (search?.trim())
                navigate(`/categories?search=${encodeURIComponent(search)}`);
            }}
          >
            Search Now
          </button>
        </div>

        <div className="search-bar mobile">
          <div className="input-wrapper">
            <Form.Control
              type="text"
              placeholder="Search product here..."
              className="search-input"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  navigate(`/categories?search=${encodeURIComponent(search)}`);
                }
              }}
            />
            <div
              className="search_icon_div"
              onClick={() => {
                if (search?.trim())
                  navigate(`/categories?search=${encodeURIComponent(search)}`);
              }}
            >
              <FontAwesomeIcon
                icon={faMagnifyingGlass}
                className="search-icon"
              />
            </div>
          </div>
        </div>

        {/* <div className="category-list">
          {healt_concerns?.map((item, index) => (
            <div
              className="category-item"
              key={index}
              onClick={() =>
                navigate(`/categories?concern_id=${encodeId(item?.id)}`)
              }
            >
              <div className="text-p">
                {item?.image && (
                  <div className="icon_holder">
                    <img
                      src={process.env.REACT_APP_IMG_URL + item?.image}
                      className="inner_img"
                    />
                  </div>
                )}

                <p className="inner_text">{item.name}</p>
              </div>
            </div>
          ))}
        </div> */}

        {healt_concerns.length > 0 && (
          <div className="category-list">
            <Swiper
              modules={[Autoplay, FreeMode]}
              slidesPerView="auto"
              spaceBetween={16}
              loop={true}
              freeMode={true}
              speed={3000}
              allowTouchMove={true}
              grabCursor={true}
              autoplay={{
                delay: 0,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              className="category-swiper"
            >
              {healt_concerns?.map((item, index) => (
                <SwiperSlide
                  className="category-slide"
                  key={`${item?.id}-${index}`}
                >
                  <div
                    className="category-item"
                    onClick={() =>
                      navigate(`/categories?concern_id=${encodeId(item?.id)}`)
                    }
                  >
                    <div className="text-p">
                      {item?.image && (
                        <div className="icon_holder">
                          <img
                            src={process.env.REACT_APP_IMG_URL + item?.image}
                            className="inner_img"
                            alt={item?.name}
                            draggable={false}
                          />
                        </div>
                      )}
                      <p className="inner_text">{item?.name}</p>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        )}
      </div>
    </div>
  );
}

export default SearchNow;
